/**
 * Formata uma data ISO string para exibição em pt-BR
 * Trata corretamente datas em UTC para evitar problema de fuso horário
 */
export function formatDate(isoString: string | null): string {
    if (!isoString) return '-';
    
    // Parse a data considerando que vem em UTC
    const date = new Date(isoString);
    
    // Extrai ano, mês e dia em UTC para evitar conversão de fuso
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    
    // Retorna no formato DD/MM/YYYY
    return `${day}/${month}/${year}`;
}

/**
 * Formata uma data ISO string para exibição em pt-BR (versão alternativa usando toLocaleDateString com UTC)
 */
export function formatDateAlt(isoString: string | null): string {
    if (!isoString) return '-';
    
    const date = new Date(isoString);
    
    // Usa toLocaleDateString mas com timeZone UTC para evitar conversão
    return date.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
}

/** Retorna o primeiro e o último dia do mês vigente no formato YYYY-MM-DD. */
export function getCurrentMonthDateRange(): { startDate: string; endDate: string } {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const lastDay = new Date(year, now.getMonth() + 1, 0).getDate();
    const pad = (n: number) => String(n).padStart(2, '0');
    return {
        startDate: `${year}-${pad(month)}-01`,
        endDate: `${year}-${pad(month)}-${pad(lastDay)}`,
    };
}





